function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M34.67 21.78V8.36c0-2.95-2.4-5.36-5.34-5.36h-24A5.35 5.35 0 000 8.37v13.4c0 2.96 2.4 5.37 5.33 5.37v4.54a.8.8 0 001.3.66l6.9-5.2h15.8c2.95 0 5.34-2.4 5.34-5.36zm8-5.37h-5.34v5.37c0 4.43-3.59 8.04-8 8.04H16v5.37c0 2.96 2.4 5.36 5.33 5.36h10.48l6.9 5.2A.8.8 0 0040 45.1v-4.55h2.67c2.94 0 5.33-2.4 5.33-5.36V21.78c0-2.96-2.4-5.37-5.33-5.37z"
})));